// material-ui
import { useTheme } from '@mui/material/styles';
import WiseShiftLogo from '../../assets/images/WiseShift.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
      <>
        <img
          src={WiseShiftLogo}
          alt="WiseShift Logo"
          width={158}
          height={55}
          style={{ objectFit: 'contain' }}
        />
      </>
    );
}
